import React from "react";
import { Badge } from "react-bootstrap";
const AlertBadge = ({ type, text, className, onClick }) => {
    let badgeType;
    switch (type.toLowerCase()) {
        case "warning":
            badgeType = "warning";
            break;
        case "critical":
            badgeType = "danger";
            break;
        case "dark":
            badgeType = "dark";
            break;
        case "secondary":
            badgeType = "secondary";
            break;
        case "success":
            badgeType = "success";
            break;
        case "primary":
            badgeType = "primary";
            break;
        case "firing":
            badgeType = "danger";
            break;
        case "resolved":
            badgeType = "success";
            break;
        default:
            badgeType = "primary";
            break;
    }
    return (React.createElement(Badge, { className: className, pill: false, bg: `${badgeType}`, onClick: onClick }, `${text}`));
};
export default AlertBadge;
